import Toastify from "toastify-js";
import "datatables.net-dt/css/dataTables.dataTables.css";
import DataTable from "datatables.net-dt";

class Wishlist {
    constructor() {
        this.activeSearchQuery = "";
        this.isRefreshing = false;
        this.ajaxThrottle = null;
        this.selectedProducts = [];
        this.wishListSelect = $("#printWishlistOptions");
        this.downloadWishlistFilesSelect = $("#downloadWishlistFiles");
        // this.importExcelSelect = $("#importExcelSelect");
        this.wishListTable = null;

        this.wlm = $("#wishlistModal");
        this.maw = $(".woocommerce-account .wishlist-wrapper");
        this.wla = $(".wishlist-actions");

        const self = this;

        $(document).ready(function () {
            self.modal();
            self.myaccount();
            self.initWishListDropdown();
            self.initDownloadWishlistDropdown(); // Initialize the new download dropdown
            self.initImportExcelDropdown();
            self.initDataTables();
            self.checkImportStatus();
        });
    }

    // New method to check for import status
    checkImportStatus() {
        const urlParams = new URLSearchParams(window.location.search);
        const importStatus = urlParams.get('wishlist_import_status');

        if (importStatus) {
            const toastMessage = {
                text: '',
                backgroundColor: '',
            };

            if (importStatus === 'success') {
                toastMessage.text = "Excel-filen har importerats!";
                toastMessage.backgroundColor = "#4caf50";
            } else if (importStatus === 'failure') {
                toastMessage.text = "Misslyckades med att importera filen. Försök igen.";
                toastMessage.backgroundColor = "#f44336";
            } else if (importStatus === 'invalid_file') {
                toastMessage.text = "Ogiltig Excel-fil. Kontrollera att filen är korrekt formaterad.";
                toastMessage.backgroundColor = "#f44336";
            }

            Toastify({
                text: toastMessage.text,
                duration: 3000,
                gravity: "top",
                position: "center",
                backgroundColor: toastMessage.backgroundColor,
                close: true,
            }).showToast();
        }
    }

    initWishListDropdown() {
        if (!this.wishListSelect.length) {
            return;
        }

        this.wishListSelect.on("change", function (e) {
            const selectedOption = e.target.options[e.target.selectedIndex];
            const redirectUrl = selectedOption.getAttribute("data-url");

            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        });
    }

    initDownloadWishlistDropdown() {
        if (!this.downloadWishlistFilesSelect.length) {
            return;
        }

        this.downloadWishlistFilesSelect.on("change", (e) => {
            const selectedOption = e.target.options[e.target.selectedIndex].value;

            if (selectedOption) {
                const listId = this.downloadWishlistFilesSelect.data("list-id");

                if (!listId) {
                    console.error("List ID is missing.");
                    return;
                }

                let downloadAction = '';

                // Determine the action type based on selection
                if (selectedOption === "downloadAllProductManuals") {
                    downloadAction = "all_manuals";
                } else if (selectedOption === "downloadPrescriptiveTexts") {
                    downloadAction = "prescriptive_texts";
                } else if (selectedOption === "downloadAllCADFiles") {
                    downloadAction = "all_cad_files";
                }

                if (downloadAction) {
                    // Show loader
                    const spinner = $("#spinner-download");
                    const selectElement = $("#downloadWishlistFiles");

                    selectElement.css("opacity", "0.5");
                    spinner.show();
                    // Perform the AJAX request
                    $.ajax({
                        url: ajax.url,
                        method: "POST",
                        data: {
                            action: "download_wishlist_files",
                            list_id: listId,
                            download_action: downloadAction
                        },
                        success: function (response) {

                            spinner.hide();
                            selectElement.css("opacity", "1");
                            if (response.success && response.data.file_url) {
                                Toastify({
                                    text: "Filen har laddats ned.",
                                    backgroundColor: "#4caf50",
                                    duration: 3000,
                                    gravity: "top",
                                    position: "center",
                                }).showToast();

                                window.location.href = response.data.file_url;
                            } else {
                                Toastify({
                                    text: "Inga filer hittades för nedladdning.",
                                    backgroundColor: "#f44336",
                                    duration: 3000,
                                    gravity: "top",
                                    position: "center",
                                }).showToast();
                            }
                        },
                        error: function () {
                            $("#wishlist-loader").hide();

                            Toastify({
                                text: "Något gick fel. Försök igen.",
                                backgroundColor: "#f44336",
                                duration: 3000,
                                gravity: "top",
                                position: "center",
                            }).showToast();
                        }
                    });
                }
            }
        });
    }
    initImportExcelDropdown() {
        this.importExcelSelect = $("#importExcelSelect"); // Se till att elementet finns
        this.fileUpload = $("#fileUpload"); // Se till att elementet finns

        // Kontrollera om elementen finns
        if (this.importExcelSelect.length === 0 || this.fileUpload.length === 0) {
            return; // Avsluta om något av elementen inte hittas
        }

        // Lyssna på ändringar i dropdownen
        this.importExcelSelect.on("change", (e) => {
            if (this.importExcelSelect.val() === "importExcel") {
                this.fileUpload.click();
            }
        });

        // Lyssna på ändringar i file upload
        this.fileUpload.on("change", () => {
            this.showSpinner(); // Anropa showSpinner som en metod av klassen
        });
    }


    showSpinner() {
        // Hämta elementen från DOM
        const importExcelSelect = document.getElementById('importExcelSelect');
        const spinnerExcel = document.getElementById('spinner-excel');

        // Kontrollera om importExcelSelect finns innan vi manipulerar stilen
        if (importExcelSelect) {
            importExcelSelect.style.opacity = '0.5';
            importExcelSelect.style.pointerEvents = 'none'; // Inaktivera klick på dropdown
        } else {
            console.error("Elementet med ID 'importExcelSelect' hittades inte.");
        }

        // Kontrollera om spinnerExcel finns innan vi visar den
        if (spinnerExcel) {
            // Sätt display till 'flex' och logga resultatet efter en fördröjning
            spinnerExcel.style.display = 'flex';

        } else {
            console.error("Elementet med ID 'spinner-excel' hittades inte.");
        }
    }





    initDataTables() {
        var columnNames = {
            0: "product",
            1: "price",
            2: "total_cost",
            3: "quantity",
            4: "add_item_to_cart",
            5: "remove_list_item"
        };

        // Retrieve saved sorting preferences
        function getSavedSortingPreferences() {
            const databaseSortingValue =
                document.getElementById("list_datatable_sorting")?.value ??
                false;
            //console.log("Database sorting value:", databaseSortingValue);

            if (!databaseSortingValue) return null;

            // Parse the JSON string to an object
            let list_datatable_sorting = JSON.parse(databaseSortingValue);
            console.log("List datatable sorting:", list_datatable_sorting);

            // Extract the column name from list_datatable_sorting
            let columnName = list_datatable_sorting.order_by;
            console.log("Column name:", columnName);

            // Find the index of the column name in columnNames
            let columnIndex = Object.values(columnNames).indexOf(columnName);
            console.log("Column index:", columnIndex);

            // Check if the column name exists in columnNames object
            if (columnIndex !== -1) {
                // Return the saved sorting preferences
                let savedSorting = {
                    column: columnIndex,
                    direction: list_datatable_sorting.order
                };
                console.log("Saved sorting:", savedSorting);
                return savedSorting;
            } else {
                console.error("Column name not found:", columnName);
                return null;
            }
        }

        // Save sorting preferences to localStorage
        function saveSortingPreferences(column, direction) {
            localStorage.setItem(
                "datatable_sorting",
                JSON.stringify({ column: column, direction: direction })
            );
            let listId = $("#list_datatable_sorting").attr("data-listid");
            console.log("List ID:", listId);
            if (direction == "") {
                direction = "asc";
            }
            const body = {
                action: "save_list_sorting_preferences",
                data: { order_by: column, order: direction, listId: listId },
                nonce: ajax.nonce // Using the localized nonce
            };

            // jQuery ajax request
            $.ajax({
                url: ajax.url, // Path to your PHP endpoint
                method: "POST",
                action: "save_list_sorting_preferences",
                data: body,
                success: function (response) {
                    if (!response.success) {
                        console.error("Failed to update sorting preferences");
                        return;
                    }
                    $("#list_datatable_sorting").val(
                        JSON.stringify(response.data)
                    );
                },
                error: function (xhr) {
                    console.error("Failed to update sorting preferences");
                }
            });

            //console lgo it
            console.log("Sorting preferences saved");
        }

        var savedSorting = getSavedSortingPreferences();

        this.wishListTable = new DataTable("#product_list_wishlist", {
            paging: false,
            searching: false,
            order: savedSorting
                ? [[savedSorting.column, savedSorting.direction]]
                : [[0, "asc"]],
            columnDefs: [
                {
                    targets: 0 // Assuming the first column is for product details
                    // "orderData": [0, 1] // Primary sort by product details, secondary by price
                },
                {
                    targets: 1, // Targets the price column for special sorting
                    render: function (data, type, row) {
                        if (type === "sort") {
                            // Strip HTML tags and non-numeric characters, then parse as float
                            var numericPrice = parseFloat(
                                data
                                    .replace(/<[^>]*>?/gm, "")
                                    .replace(/[^\d.-]/g, "")
                            );
                            return numericPrice; // Return as numeric value
                        }
                        return data; // Return original data for other types
                    },
                    type: "num" // Ensure the column is treated as numeric
                },
                {
                    targets: 2, // Targets the total price column for special sorting
                    render: function (data, type, row) {
                        if (type === "sort") {
                            // Strip HTML tags and non-numeric characters, then parse as float
                            var numericPrice = parseFloat(
                                data
                                    .replace(/<[^>]*>?/gm, "")
                                    .replace(/[^\d.-]/g, "")
                            );
                            return numericPrice; // Return as numeric value
                        }
                        return data; // Return original data for other types
                    },
                    type: "num" // Ensure the column is treated as numeric
                    // "orderSequence": ["asc", "desc"] // Define the order sequence for sorting
                },
                {
                    targets: 3, // Quantity column
                    render: function (data, type, row) {
                        if (type === "sort") {
                            // Extract the value from the quantity input element
                            var quantity = $(data)
                                .find('input[type="number"]')
                                .val();
                            return parseInt(quantity);
                        }
                        return data;
                    },
                    type: "num" // Ensure numeric sorting
                },
                {
                    targets: [4, 5, 6], // Disable sorting on action buttons and status
                    orderable: false
                }
            ],
            initComplete: function () {
                var api = this.api();
                api.on("order.dt", function () {
                    let order = api.order()[0];
                    let orderColumnIndex = order[0];
                    let orderDirection = order[1];
                    let orderColumnName = columnNames[orderColumnIndex];
                    console.log("Order column:", orderColumnName);
                    console.log("Order direction:", orderDirection);

                    // Save sorting preferences to localStorage
                    saveSortingPreferences(orderColumnName, orderDirection);
                });
            }
        });
    }

    async refreshModalLists() {
        const self = this;
        const $listContainer = $(self.wlm).find(".list-container");

        this.isRefreshing = true;

        $listContainer.LoadingOverlay("show", {
            imageClass: "jquery-loading-overlay-icon",
            image: ajax.templateUrl + "/assets/svg/loading.svg",
            imageResizeFactor: 1,
            background: "rgba(255, 255, 255, 0.05)"
        });

        var req = await fetch(
            ajax.site_url + `/wp-json/gpa/wishlists/paged/${ajax.uid}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    offset: 0,
                    per_page: 20,
                    search_query: this.activeSearchQuery
                })
            }
        );

        const productIds = this.selectedProducts.map(p => p.product_id);

        var response = await req.json();

        if (response.success && response.data) {
            const { paged_lists, total_list_count } = response.data;

            let html = "";

            if (!total_list_count) {
                html = `<h6 class="text-center mt-2">${ajax.lang_str.wishlist.txt_no_lists}</h6>`;
            } else if (!Object.keys(paged_lists).length) {
                html = `<h6 class="text-center mt-2">${ajax.lang_str.wishlist.txt_no_items_found}</h6>`;
            } else {
                html = `<ul class="list-group">`;

                let lists = Object.values(paged_lists);

                lists.forEach(list => {
                    let inList = list.items.some((item, index) => {
                        return productIds.includes(item.variation_id);
                    });

                    html +=
                        `<li class="list-item d-flex align-items-center position-relative mb-2">
							<input type="checkbox" class="mr-3" name="list" id="list-${list.list_id}" value="${list.list_id}"` +
                        (inList ? `checked` : ``) +
                        `>
							<label for="list-${list.list_id}" class="m-0">${list.list_name}</label>

							<a href="${ajax.wishlist_url}/${list.list_id}" class="text-reset ml-auto" target="_blank">
							<span
								class="font-weight-normal d-flex justify-content-center px-2 py-1 text-primary bg-icef-light fs-12 align-items-center cursor-pointer"
								>
								${ajax.lang_str.wishlist.txt_go_to_link} →
							</span>
						</a>
					</li>`;
                });

                html += `</ul>`;
            }

            $listContainer.html(html);

            // Add event listener to checkboxes and unattach if already attached
            $listContainer.find("input[type=checkbox]").off("change");

            $listContainer
                .find("input[type=checkbox]")
                .on("change", function (e) {
                    e.preventDefault();

                    const listId = $(this).val();
                    const isChecked = $(this).is(":checked");

                    // Create a fetch to create a new list
                    let requestData = {
                        action: "wishlist_ajax",
                        do: "add_items",
                        nonce: ajax.nonce,
                        list_id: listId,
                        products: JSON.stringify(self.selectedProducts)
                    };

                    if (!isChecked) {
                        requestData.do = "remove_items";
                    }

                    // Add class
                    $(this)
                        .closest(".list-item")
                        .addClass("wc-button-loading-relative blue");

                    // Fetch using fetch
                    fetch(ajax.url, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: new URLSearchParams(requestData).toString()
                    })
                        .then(response => response.json())
                        .then(response => {
                            if (!response.success && !isChecked) {
                                $(this).prop("checked", true);
                            }

                            $(this)
                                .closest(".list-item")
                                .append(
                                    `<div class="ada-status ml-2 fs-12 success">${response.data}</div>`
                                );
                        })
                        .finally(() => {
                            // Remove class
                            $(this)
                                .closest(".list-item")
                                .removeClass("wc-button-loading-relative blue");

                            // Remove message
                            setTimeout(() => {
                                $(this)
                                    .closest(".list-item")
                                    .find(".ada-status")
                                    .remove();
                            }, 2000);
                        });
                });

            $listContainer.LoadingOverlay("hide");
            this.isRefreshing = false;
        } else {
            $listContainer.html(
                `<h6 class="text-center mt-2">${ajax.lang_str.wishlist.txt_generic_error}</h6>`
            );
        }
    }

    async refreshAccountLists() {
        const self = this;

        const savedSearchQuery = localStorage.getItem("wishlist_search_query");

        // Try to get and set local search query
        if (savedSearchQuery && savedSearchQuery.length) {
            this.activeSearchQuery = savedSearchQuery;
        }

        const $listContainer = this.maw.find(".productlists");

        this.isRefreshing = true;

        $listContainer.LoadingOverlay("show", {
            imageClass: "jquery-loading-overlay-icon",
            image: ajax.templateUrl + "/assets/svg/loading.svg",
            imageResizeFactor: 1,
            background: "rgba(255, 255, 255, 0.05)"
        });

        this.maw.find(".pagination-top").html("");

        var req = await fetch(ajax.url, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
                action: "wishlist_ajax",
                do: "get_lists",
                nonce: ajax.nonce,
                search_query: this.activeSearchQuery,
                paged: 0
            }).toString()
        });

        var response = await req.json();

        if (response.success && response.data) {
            const { lists, total_list_count, pagination_html } = response.data;

            let html = "";

            if (!total_list_count) {
                html = `<h6 class="text-center mt-2">${ajax.lang_str.wishlist.txt_no_lists}</h6>`;
            } else if (!Object.keys(lists).length) {
                html = `<h6 class="text-center mt-2">${ajax.lang_str.wishlist.txt_no_items_found}</h6>`;
            } else {
                const tableHeaders = {
                    list_name: ajax.lang_str.wishlist.txt_col_listname,
                    list_total_products:
                        ajax.lang_str.wishlist.txt_col_total_products,
                    list_total_price:
                        ajax.lang_str.wishlist.txt_col_list_total_price,
                    add_list_to_cart:
                        ajax.lang_str.wishlist.txt_col_add_list_to_cart,
                    remove_list_item:
                        ajax.lang_str.wishlist.txt_col_remove_list_item
                };

                html = `
				<table
				class="woocommerce-wishlist-table woocommerce-MyAccount-wishlist shop_table shop_table_responsive my_account_wishlist account-wishlist-table fixed-mobile">
				<thead>
					<tr class="d-none d-md-table-row">
						`;

                Object.entries(tableHeaders).forEach(([index, header]) => {
                    html += `<th
								class="woocommerce-wishlist-table__header woocommerce-wishlist-table__header-${index} py-3">
								<span class="nobr">${header}</span>
								</th>`;
                });

                html += `
					</tr>
				</thead>

				<tbody>`;

                let tableData = "";

                for (const list of lists) {
                    let name = list.list_name;
                    let list_id = list.list_id;
                    let total_articles = list.items.length;
                    let total_cost = list.total_cost_prefix;
                    let single_wishlist_url = `${ajax.wishlist_url}/${list.list_id}`;

                    tableData += `<!-- Mobile view -->
					<tr class="d-table-row d-md-none">
						<td colspan="9" class="p-0">
							<div class="bg-white">
								<ul class="details list-unstyled list-group text-left p-3">
									<li class="pb-1">
										<a href="${single_wishlist_url}/${list_id}" class="text-reset">
											<strong>${ajax.lang_str.wishlist.txt_col_listname}</strong> <span
												class="font-weight-normal">
												${name}       <svg class="svg-icon fill-primary">
												<use xlink:href="#icon-edit"></use>
											</svg></span>
										</a>
									</li>
									<li class="pb-1"><strong>${ajax.lang_str.wishlist.txt_col_total_products}</strong> <span
											class="font-weight-normal">${total_articles}</span></li>
									<li class="pb-1"><strong>${ajax.lang_str.wishlist.txt_col_list_total_price}</strong> <span
											class="font-weight-normal">${total_cost}</span></li>
									<li class="pb-1 d-flex">`;

                    if (total_articles > 0) {
                        tableData += `<a href="#" class="add-list-to-cart" data-list-id="${list_id}">
											<div class="d-flex justify-content-start align-items-start font-weight-normal">
												<span class="text-primary full">
												${ajax.lang_str.wishlist.txt_col_add_list_to_cart}</span>
												       <svg class="svg-icon fill-primary">
                                            <use xlink:href="#icon-shopping-cart"></use>
                                        </svg>
											</div>
										</a>`;
                    }

                    tableData += `
									</li>
									<li class="pb-1"><strong><a href="#" data-list-id="${list_id}"
												class="remove-list">${ajax.lang_str.wishlist.txt_col_remove_list_item}</strong> <span
											class="font-weight-normal">       <svg class="svg-icon fill-primary">
                                            <use xlink:href="#icon-remove"></use>
                                        </svg></span></a></li>
								</ul>
							</div>
						</td>
					</tr>

					<!-- Desktop view -->
					<tr
						class="woocommerce-wishlist-table__row woocommerce-wishlist-table__row--status-1 order d-none d-md-table-row wishlist-tr">

						<td>
							<a href="${single_wishlist_url}/${list_id}" class="text-reset">
								<span
									class="font-weight-normal d-flex justify-content-center align-items-center cursor-pointer"
									id="wishlist-1">
									<span>
										${name}
									</span>
									<div class="pl-2 mb-1">
									<svg class="svg-icon">
									<use xlink:href="#icon-edit"></use>
								</svg>
									</div>
								</span>
							</a>
						</td>
						<td> <span class="font-weight-normal">${total_articles}</span></td>
						<td> <span class="font-weight-normal">${total_cost}</span>
						</td>
						<td>`;

                    if (total_articles > 0) {
                        tableData += `
							<span class="font-weight-normal">
								<a href="#" class="add-list-to-cart" data-list-id="${list_id}">
									<div class="d-flex justify-content-center align-items-center font-weight-normal">
										<span class="pr-1 text-primary full fs-16">
										${ajax.lang_str.wishlist.txt_col_add_to_cart}</span>
										       <svg class="svg-icon fill-primary">
                                            <use xlink:href="#icon-shopping-cart"></use>
                                        </svg>
									</div>
								</a>
							</span>
							`;
                    }

                    tableData += `
						</td>
						<td><span class="font-weight-normal"><a href="#" data-list-id="${list_id}>"
									class="remove-list">       <svg class="svg-icon fill-primary">
                                            <use xlink:href="#icon-remove"></use>
                                        </svg></a></span></td>
					</tr>
				`;
                }

                html += `${tableData}</tbody>
				</table>`;

                // Replace pagination count
                let tot_str = ajax.lang_str.wishlist.txt_tot_list_col;

                tot_str = tot_str.replace("%d", lists.length);
                tot_str = tot_str.replace("%d", total_list_count);

                this.maw.find(".pagination-top").html(tot_str);
            }

            if (pagination_html && lists.length) {
                html += `
				<div class="pagination d-flex justify-content-center mt-5">
					${pagination_html}
				</div>
				`;
            } else {
                $listContainer.find(".pagination").remove();
            }

            $listContainer.html(html);
        } else {
            $listContainer.html(
                `<h6 class="text-center mt-2">${ajax.lang_str.wishlist.txt_generic_error}</h6>`
            );
        }

        // Add event listener to remove etc
        this.isRefreshing = false;

        $listContainer.LoadingOverlay("hide");
    }

    createNewModalList(listName, listContainer, listForm = false, callback) {
        let requestData = {
            action: "wishlist_ajax",
            do: "create_list",
            nonce: ajax.nonce,
            list_name: listName
        };

        // Remove all errors with class error in element listForm
        listForm && listForm.find(".ada-status").remove();

        // Set loading status on button
        $(this)
            .css("pointer-events", "none")
            .css("opacity", "0.5");

        listContainer.LoadingOverlay("show", {
            imageClass: "jquery-loading-overlay-icon",
            image: ajax.templateUrl + "/assets/svg/loading.svg",
            imageResizeFactor: 1,
            zIndex: 800,
            background: "rgba(255, 255, 255, 0.5)"
        });

        // Send request to create list
        const promise = fetch(ajax.url, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams(requestData).toString()
        }).then(response => {
            return response.json();
        });

        callback(promise);
    }

    myaccount() {
        const self = this;

        const toastDefs = {
            text: "",
            duration: 5000,
            escapeMarkup: false,
            newWindow: true,
            close: true,
            gravity: "top", // `top` or `bottom`
            position: "center", // `left`, `center` or `right`
            stopOnFocus: true, // Prevents dismissing of toast on hover
            style: {
                background: "#007b92"
            }
        };

        const setSearchQuery = () => {
            // Set local storage
            localStorage.setItem(
                "wishlist_search_query",
                self.activeSearchQuery
            );

            // Update get parameter
            const url = new URL(window.location.href);
            const params = url.searchParams;

            while (params.keys().next().done === false) {
                params.delete(params.keys().next().value);
            }

            url.searchParams.set("sq", self.activeSearchQuery);
            window.history.replaceState({}, "", url);

            // Update search input
            self.maw.find(".search-list").val(self.activeSearchQuery);
        };

        $(document).on("wishlist_product_quantity_update", function (e, data) {
            const { element } = data;
            let $parent = $(element).closest("tr");

            let listId = $parent.data("list-id");
            let variationId = $parent.data("variation-id");
            let quantity = $(element).val();
            let product_price = $parent
                .find(".price .woocommerce-Price-amount bdi")
                .text()
                .replace(/[^\d.]/g, "");

            if ($parent.length) {
                if (typeof self.ajaxThrottle == "number") {
                    clearTimeout(self.ajaxThrottle);
                    self.ajaxThrottle = null;
                }

                if (!self.ajaxThrottle) {
                    self.ajaxThrottle = setTimeout(() => {
                        let requestData = {
                            nonce: ajax.nonce,
                            action: "wishlist_ajax",
                            do: "update_qty",
                            list_id: listId,
                            variation_id: variationId,
                            quantity: quantity,
                            product_price: product_price
                        };

                        fetch(ajax.url, {
                            method: "POST",
                            headers: {
                                "Content-Type":
                                    "application/x-www-form-urlencoded"
                            },
                            body: new URLSearchParams(requestData).toString()
                        })
                            .then(response => {
                                return response.json();
                            })
                            .then(data => {
                                let newTotalPrice = data.data.new_total_price;
                                $parent
                                    .find(".total-price")
                                    .html(newTotalPrice);

                                // Update the table sorting
                                self.wishListTable
                                    .rows()
                                    .invalidate()
                                    .draw();
                            });
                    }, 500);
                }
            }
        });

        self.wla.on("click", ".add-new-list", function (e) {
            e.preventDefault();

            self.wla.find(".new-list-name").val("");
            self.wla.find(".new-list-form").toggleClass("d-none");
        });

        self.wla.on("click", ".create-list", function (e) {
            // Create a fetch to create a new list
            const listName = self.wla.find(".new-list-name-input").val();
            const $listContainer = self.wla.find(".new-list-form");

            self.createNewModalList(listName, $listContainer, false, promise =>
                promise
                    .then(data => {
                        const { data: message } = data;

                        if (data.success) {
                            Toastify({
                                ...toastDefs,
                                text: message
                            }).showToast();

                            window.location.reload();
                        } else {
                            // Trigger .catch error
                            throw new Error(
                                ajax.lang_str.wishlist.txt_generic_error
                            );
                        }
                    })
                    .catch(error => {
                        Toastify({
                            ...toastDefs,
                            text:
                                error ||
                                ajax.lang_str.wishlist.txt_generic_error
                        }).showToast();
                    })
            );
        });

        this.maw.on("keyup", ".search-list", function (e) {
            e.preventDefault();

            let timeout = 1000;

            // If key is enter, search immediately
            if (e.keyCode == 13) {
                timeout = 0;
            }

            self.activeSearchQuery = $(this).val();

            if (typeof self.ajaxThrottle == "number") {
                clearTimeout(self.ajaxThrottle);
                self.ajaxThrottle = null;
            }

            if (!self.isRefreshing && !self.ajaxThrottle) {
                self.ajaxThrottle = setTimeout(() => {
                    setSearchQuery();
                    self.refreshAccountLists();
                }, timeout);
            }
        });

        this.maw.on("click", ".add-item-to-cart", async function (e) {
            e.preventDefault();

            const $parent = $(this).closest("tr");
            var $site_content = $("#site-content > .container");

            $parent.css("opacity", ".5").css("pointer-events", "none");

            var formData = {
                product_sku: $parent.data("sku"),
                product_id: $parent.data("product-id"),
                variation_id: $parent.data("variation-id"),
                quantity: $parent
                    .find(".grouped-quantity-input .quantity input.qty")
                    .val(),
                action: "wc_ajax_add_to_cart"
            };

            $.ajax({
                url: wc_add_to_cart_params.ajax_url,
                type: "POST",
                processData: true,
                data: formData,
                success: function (response) {
                    console.log(response);
                    if (response.error & response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else {
                        $(".woocommerce-notices-wrapper").remove();

                        $(document.body).trigger("added_to_cart", [
                            response.fragments,
                            response.cart_hash
                        ]);
                    }

                    $parent.css("pointer-events", "all").css("opacity", "1");

                    // Remove existing notices
                    $(
                        ".woocommerce-error, .woocommerce-message, .woocommerce-info"
                    ).remove();

                    // Add new notices
                    $site_content.before(response.fragments.notices_html);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    //console.log(jqXHR);
                    //console.log(textStatus);
                    //console.log(errorThrown);
                },
                complete: function () {
                    $parent.css("pointer-events", "all").css("opacity", "1");
                }
            });
        });

        this.maw.on("click", ".add-list-to-cart", async function (e) {
            e.preventDefault();

            const $parent = $(this).closest("tr");
            const listId = $(this).data("list-id");

            // Reload this page dynamicaly with ?bulk-add-from-list
            const url = new URL(window.location.href);
            url.searchParams.set("bulk-add-from-list", listId);

            $(this)
                .css("opacity", ".5")
                .css("pointer-events", "none");
            $parent.css("opacity", ".5").css("pointer-events", "none");

            window.location.href = url;
        });

        this.maw.on("submit", ".search-form", function (e) {
            e.preventDefault();
        });

        this.maw.on("click", ".remove-list", async function (e) {
            e.preventDefault();

            const $parent = $(this).closest("tr");
            const listId = $(this).data("list-id");

            if (!confirm(ajax.lang_str.wishlist.txt_remove_list)) {
                return false;
            }

            let requestData = {
                nonce: ajax.nonce,
                action: "wishlist_ajax",
                do: "remove",
                what: "list",
                list_id: listId
            };

            $parent.css("opacity", ".5").css("pointer-events", "none");

            fetch(ajax.url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams(requestData).toString()
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    $parent.remove();

                    // Remove query string from URL
                    const url = new URL(window.location.href);
                    url.searchParams.delete("bulk-add-from-list");

                    window.location.href = url;
                })
                .catch(error => {
                    Toastify({
                        ...toastDefs,
                        text: error
                    }).showToast();
                })
                .finally(() => {
                    $parent.css("opacity", "1").css("pointer-events", "all");
                });
        });

        this.maw.on("click", ".remove-list-item", async function (e) {
            e.preventDefault();

            const $parent = $(this).closest("tr");
            const itemId = $(this).data("list-item-id");
            const listId = $(this).data("list-id");

            if (!confirm(ajax.lang_str.wishlist.txt_remove_item)) {
                return false;
            }

            let requestData = {
                nonce: ajax.nonce,
                action: "wishlist_ajax",
                do: "remove",
                what: "item",
                list_id: listId,
                item_id: itemId
            };

            $parent.css("opacity", ".5").css("pointer-events", "none");

            fetch(ajax.url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams(requestData).toString()
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    const { data: message } = data;

                    if (!data.success) {
                        toastDefs.style = {
                            background: "#bd5050"
                        };
                    }

                    Toastify({
                        ...toastDefs,
                        text:
                            message || ajax.lang_str.wishlist.txt_generic_error
                    }).showToast();

                    $parent.remove();

                    // Remove query string from URL
                    const url = new URL(window.location.href);
                    url.searchParams.delete("bulk-add-from-list");

                    window.location.href = url;
                })
                .catch(error => {
                    Toastify({
                        ...toastDefs,
                        text: error
                    }).showToast();
                })
                .finally(() => {
                    $parent.css("opacity", "1").css("pointer-events", "all");
                });
        });
    }

    modal() {
        const self = this;

        const toastDefs = {
            text: "",
            duration: 5000,
            escapeMarkup: false,
            newWindow: true,
            close: true,
            gravity: "top", // `top` or `bottom`
            position: "center", // `left`, `center` or `right`
            stopOnFocus: true, // Prevents dismissing of toast on hover
            style: {
                background: "#007b92"
            }
        };

        // Listen for when modal closes
        this.wlm.on("hidden.bs.modal", function (e) {
            $(".adc-status").remove();
        });

        $(document).on("keyup", "#wishlistModal .search-list", function (e) {
            e.preventDefault();

            self.activeSearchQuery = $(this).val();

            if (typeof self.ajaxThrottle == "number") {
                clearTimeout(self.ajaxThrottle);
                self.ajaxThrottle = null;
            }

            if (!self.isRefreshing && !self.ajaxThrottle) {
                self.ajaxThrottle = setTimeout(() => {
                    self.refreshModalLists();
                }, 1000);
            }
        });

        // Create list
        $(document).on("click", "#wishlistModal .create-list", function (e) {
            e.preventDefault();

            // Create a fetch to create a new list
            const $btn = $(this);
            const listName = self.wlm.find(".new-list-name-input").val();
            const listForm = self.wlm.find(".new-list-form");
            const $listContainer = $(self.wlm).find(".list-container");

            $btn.css("opacity", ".5")
                .css("pointer-events", "auto")
                .prop("disabled", true);

            self.createNewModalList(
                listName,
                $listContainer,
                listForm,
                promise => {
                    promise
                        .then(data => {
                            const { data: message } = data;

                            if (data.success) {
                                self.refreshModalLists();
                                listForm &&
                                    listForm.prepend(
                                        `<div class="ada-status alert alert-primary">${message}</div>`
                                    );
                            } else {
                                listForm &&
                                    listForm.prepend(
                                        `<div class="ada-status alert alert-danger">${message}</div>`
                                    );
                            }
                        })
                        .catch(error => {
                            listForm &&
                                listForm.prepend(
                                    `<div class="ada-status alert alert-danger">${error}</div>`
                                );
                        })
                        .finally(() => {
                            // Remove loading status on button
                            $btn.css("pointer-events", "auto")
                                .css("opacity", "1")
                                .prop("disabled", false);

                            // Fade out all ada-status after 3 seconds
                            if (listForm) {
                                setTimeout(() => {
                                    listForm.find(".ada-status").fadeOut();
                                }, 3000);
                            }

                            $listContainer.LoadingOverlay("hide");
                        });
                }
            );
        });

        // Toggle new list add-new-list
        $(document).on("click", "#wishlistModal .add-new-list", function (e) {
            e.preventDefault();

            $("#wishlistModal .new-list-name").val("");
            $("#wishlistModal .new-list-form").toggleClass("d-none");
        });

        // Open modal for wishlist cart
        $(document).on("click", ".cart-wrapper .add-new-list", async function (
            e
        ) {
            e.preventDefault();

            self.selectedProducts = [];

            fetch(ajax.url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams({
                    nonce: ajax.nonce,
                    action: "get_cart_contents"
                }).toString()
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    const { data: message } = data;

                    if (!data.success) {
                        throw new Error();
                    }

                    message.forEach(item => {
                        let filterData = {
                            product_id: item.product_id,
                            variation_id: item.variation_id,
                            quantity: item.quantity
                        };

                        self.selectedProducts.push(filterData);
                    });
                })
                .catch(error => {
                    Toastify({
                        ...toastDefs,
                        text: ajax.lang_str.wishlist.txt_generic_error
                    }).showToast();

                    self.wlm.modal("toggle");

                    return;
                });

            self.refreshModalLists();

            self.wlm.modal("show");

            return false;
        });

        // Open modal for wishlist single product
        $(document).on(
            "click",
            ".single-variation-item-actions .single_variation_add_to_wishlist_button",
            async function (e) {
                e.preventDefault();

                const $parent = $(this).closest(
                    ".single-variation-item-actions"
                );
                const $listContainer = $(self.wlm).find(".list-container");

                var $form = $(this);

                var filterData = {
                    product_id: $parent.find('input[name="add-to-cart"]').val(),
                    variation_id: $parent
                        .find('input[name="variation_id"]')
                        .val(),
                    quantity: $parent.find('input[name="quantity').val()
                };

                self.selectedProducts = [filterData];

                self.refreshModalLists();

                self.wlm.modal("show");

                return false;
            }
        );
    }
}

export default Wishlist;